const config: any = {
  api: {
    //  API_URL: "http://192.168.2.27:3001/admin/api/v1/", 
     API_URL: "https://app.vanwaala.pk/admin/api/v1/",
    // API_URL: "http://localhost:3001/admin/api/v1/",
  },
};
export default config;